import {
  initCreatorFeed,
  initHashtagFeed,
  initTaggedInFeed,
  selectIgAccount,
} from "actions/sourceMedia";
import { LIBRARY_SEARCH_TAGGED_IN } from "constants/Events";
import { useTrackEvent } from "libs/analytics";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedIgAccount } from "selectors/hashtagFeedSelectors";
import { getAccountsForPlatform } from "selectors/skedCoreSelectors";
import { AccountType } from "shared/types/accounts";
import { SingleSelectAccountDropdown } from "@/components/ui/account-selector";
import type { ReduxRootState } from "types/redux-store";

export function useInitMediaFeed() {
  const dispatch = useDispatch();
  const trackEvent = useTrackEvent();

  const initMediaFeed = (type: string, account: AccountType) => {
    switch (type) {
      case "hashtag":
        dispatch(initHashtagFeed(account._id));
        break;
      case "tagged-in":
        trackEvent({
          eventName: LIBRARY_SEARCH_TAGGED_IN,
          useServices: ["AMP"],
          metadata: { location: "picker" },
        });
        dispatch(initTaggedInFeed(account._id));
        break;
      case "creator":
        dispatch(initCreatorFeed({ accountId: account._id }));
        break;
      default:
        console.warn("no type matched");
    }
  };

  return initMediaFeed;
}

const taggedInScopeFilter = (account: AccountType) =>
  (account.session?.scopes || []).includes("instagram_manage_comments");

export function AccountSelector({ type }: { type: string }) {
  const dispatch = useDispatch();

  const accounts = useSelector((state: ReduxRootState) =>
    getAccountsForPlatform(state, "IG")
  );

  const initMediaFeed = useInitMediaFeed();
  const selectedIgAccount = useSelector(getSelectedIgAccount);

  const onAccountSelect = (account: AccountType) => {
    dispatch(selectIgAccount(account._id));
    initMediaFeed(type, account);
  };

  return (
    <SingleSelectAccountDropdown
      accounts={accounts}
      value={selectedIgAccount ?? undefined}
      onChange={onAccountSelect}
      platforms={["IG"]}
      scopeFilter={type === "tagged-in" ? taggedInScopeFilter : undefined}
      className="w-[280px]"
    />
  );
}
